/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";
import Loader from "react-loader";
import {
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import moment from "moment";

// components
import MainLayout from "../../components/hoc/MainLayout";
import DateFilter from "../../components/DateFilter";
import Export from "../../components/reports/ExportRiders";
import { makeStyles } from "@material-ui/core/styles";

// helpers
import { apiGet } from "../../helpers/api";
import displayName from "../../helpers/displayName";
import displayDuration from "../../helpers/displayDuration";

const useStyles = makeStyles(() => ({
  table: { minWidth: 650 },
  noResults: { fontStyle: "italic", color: "#b99d9d" },
}));

function OrdersOutdoorDeliveryTime() {
  const classes = useStyles();

  const [data, setData] = useState(null);
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [orderType, setOrderType] = useState("");

  const fetchData = useCallback(async () => {
    setData(null);

    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(endDate).format("YYYY-MM-DD");

    // get data from api
    try {
      let url = `/reports/orders_at_the_door_delivery_time?date_from=${start}&date_to=${end}`;
      if (orderType !== "") {
        url += `&type=${orderType}`;
      }
      const response = await apiGet(url);
      setData(response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  }, [startDate, endDate, orderType]);

  useEffect(() => {
    fetchData();
  }, []);

  let total = 0;

  return (
    <Loader loaded={data !== null}>
      <Typography variant="h5" gutterBottom>
        Orders At The Door Delivery Time
      </Typography>

      <DateFilter
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        filterAction={fetchData}
        orderType={orderType}
        orderTypeChangeHandler={(e) => {
          setOrderType(e.target.value);
        }}
        exportComponent={{
          component: Export,
          data,
          filename: "orders-at-the-door-delivery-time",
          disabled: data?.length === 0,
        }}
      />

      <Paper square>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Date</TableCell>
                <TableCell align="left">Order ID</TableCell>
                <TableCell align="left">Rider Name</TableCell>
                <TableCell align="left">Email</TableCell>
                <TableCell align="left">Mobile #</TableCell>
                <TableCell align="left">Store</TableCell>
                <TableCell align="left">Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data !== null && Object.keys(data)?.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={6}>
                    <span className={classes.noResults}>No results found</span>
                  </TableCell>
                </TableRow>
              )}
              {data !== null &&
                Object.keys(data).map((key, idx) => {
                  const row = data[key];
                  total += row.total;

                  return (
                    <TableRow
                      key={`row_${idx}`}
                      style={{ verticalAlign: "top" }}
                    >
                      <TableCell align="left">
                        {moment(row.delivery_date).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell align="left">{row.order_id}</TableCell>
                      <TableCell align="left">
                        {displayName(row.rider?.firstName, row.rider?.lastName)}
                      </TableCell>
                      <TableCell align="left">{row.rider?.email}</TableCell>
                      <TableCell align="left">
                        {row.rider?.mobileNumber}
                      </TableCell>
                      <TableCell align="left">
                        {displayName(row.store?.firstName, row.store?.lastName)}
                      </TableCell>
                      <TableCell align="left">
                        {displayDuration(row.total)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {data !== null && Object.keys(data).length > 0 && (
                <TableRow>
                  <TableCell colSpan={5} style={{ fontWeight: "bold" }}>
                    TOTAL
                  </TableCell>
                  <TableCell align="left" style={{ fontWeight: "bold" }}>
                    {displayDuration(total)}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Loader>
  );
}

export default MainLayout(OrdersOutdoorDeliveryTime);
